import React from 'react';
import Icon from '../../../components/AppIcon';

const AchievementBadge = ({ badge, onClick }) => {
  const rarityColors = {
    'common': 'from-gray-400 to-gray-600',
    'rare': 'from-blue-400 to-blue-600',
    'epic': 'from-purple-400 to-purple-600',
    'legendary': 'from-yellow-400 to-yellow-600'
  };

  return (
    <button
      onClick={() => onClick(badge)}
      className="group relative bg-card rounded-xl p-4 border border-border hover:shadow-lg transition-all text-center"
    >
      <div className={`w-20 h-20 mx-auto mb-3 rounded-full bg-gradient-to-br ${rarityColors?.[badge?.rarity]} flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform`}>
        <Icon name={badge?.icon} size={32} color="white" />
      </div>
      <h4 className="font-semibold text-foreground text-sm mb-1">{badge?.name}</h4>
      <p className="text-xs text-muted-foreground mb-2">{badge?.description}</p>
      <div className="flex items-center justify-center gap-1 text-xs text-muted-foreground">
        <Icon name="Calendar" size={12} />
        <span>{badge?.earnedDate}</span>
      </div>
      {badge?.isNew && (
        <div className="absolute top-2 right-2 bg-accent text-accent-foreground text-xs font-bold px-2 py-1 rounded-full">
          NEW
        </div>
      )}
    </button>
  );
};

export default AchievementBadge;